export const skillsData = {
  languages: ['TypeScript', 'JavaScript', 'C++', 'Java', 'HTML'],
  frontend: ['Next.js', 'React.js', 'MUI', 'React Native', 'Ext.js'],
  backend: ['Node.js', 'Express.js', 'WebSockets'],
  cloud: ['AWS (S3, EC2, Lambda)', 'Firebase', 'MongoDB', 'MySQL'],
  tools: ['Git', 'Postman', 'Figma', 'Digital Ocean', 'Cloudflare'],
  other: [
    'Authentication (JWT, OAuth)',
    'Microservices Architecture',
    'Performance Optimization',
  ],
};

export const certifications = [
  {
    title: 'AWS Certified Cloud Practitioner',
    period: '09/2022 - 09/2025',
    validation: 'YNC1TTW1ZNB4QCSJ',
  },
  {
    title: 'Certificate of Excellence',
    period: '8/2021 - 06/2022',
    description:
      'Outstanding contributions in product team at HighRadius Technologies',
  },
];

export const workExperienceData = [
  {
    role: 'Lead Software Engineer ',
    company: 'Cleverise Tech, Pune',
    dates: 'Oct 2023 – Present',
    summary:
      'Led full-stack development across multiple high-impact B2B web platforms, working directly with clients from ideation to deployment. Collaborated with a cross-functional team of 6 developers and played a key role in shaping product architecture and delivery.',
    highlights: [
      'Developed and led two CRM systems (Tour Touch, Dynamic Diet) — used by 3 travel agencies and 1000+ clients in a diet consultancy.',
      'Created dashboards, complex forms, and data visualization using React, MUI Kit, React Hook Form, Recharts, and ApexCharts.',
      'Delivered a Quality Management System for a manufacturing firm, reducing manual errors by 95% and boosting compliance to 100%.',
      'Built a reusable API layer with React Query + Axios abstraction, reducing API integration time by 30% and improving page load speeds.',
      'Migrated 20+ frontend components for a large website (Nuskin) into a headless CMS with microfrontend architecture (React/Vue).',
      'Created a React Native mobile app with real-time chat, attendance, and academic tracking. Reduced app size by 15%.',
      'Implemented dynamic ACL (Access Control List) to ensure granular, secure permissions across 20+ enterprise modules.',
    ],
  },
  {
    role: 'Software Development Engineer',
    company: 'Brillio Technologies, Bangalore',
    dates: 'Jun 2022 – Sep 2023',
    summary:
      'Built strong foundational experience through full-stack projects and internal training, specializing in the MERN stack and Agile development practices.',
    highlights: [
      'Completed a 3-month hands-on training program in MongoDB, Express.js, React, and Node.js.',
      'Built multiple internal PoCs implementing JWT authentication, modular React components, and MongoDB-backed APIs.',
      'Achieved AWS Cloud Practitioner certification to solidify cloud fundamentals.',
    ],
  },
  {
    role: 'Product Intern',
    company: 'HighRadius Technologies, Remote',
    dates: 'Aug 2021 – Jun 2022',
    summary:
      'Contributed to internal product tools for the Sales team, assisting in UI logic, backend endpoints, and dynamic screen rendering.',
    highlights: [
      'Worked with Java, Spring Boot, and Ext JS to improve internal tooling efficiency.',
      'Helped the Sales team automate internal workflows through data-driven UI development.',
    ],
  },
];
